import React from 'react';
import { formatDateLocal } from '../../utils/dateFormat';

const StoreDayBreakdown = ({ byDay, storeId, storeName, onDayClick }) => {
  if (!byDay || byDay.length === 0) return null;
  const sorted = [...byDay].sort((a, b) => (a.date || '').localeCompare(b.date || ''));
  return (
    <tr className="bg-gray-50">
      <td colSpan={4} className="px-6 py-3">
        <div className="flex flex-wrap gap-2">
          {sorted.map(({ date, total }) => (
            <button
              key={date}
              type="button"
              onClick={() => onDayClick && onDayClick(storeId, storeName, date)}
              className="px-3 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700 text-sm hover:bg-gray-100 hover:border-gray-300 transition-colors"
            >
              {formatDateLocal(date)} — <strong className="text-gray-900">{total}</strong>
            </button>
          ))}
        </div>
      </td>
    </tr>
  );
};

export default StoreDayBreakdown;
